import { useMemo } from "react";
import { useAllCurrentSweepstakeOptionsQuery } from "@coin-microservices/sweepstakes-react-hooks";
import { FlexCol } from "../../Flex";

import EntryDialog from "../EntryDialog";
import { SweepstakesOptionsContext } from "../options";
import SweepstakesListItem from "./SweepstakesListItem";

const PLACEHOLDER_COUNT = 8;
const MAX_ITEMS = 500;

const CurrentSweepstakesListItems = () => {
  const optionsQuery = useAllCurrentSweepstakeOptionsQuery({
    variables: {
      special: true,
    },
  });
  const options = optionsQuery?.data?.allCurrentSweepstakeOptions;

  const items = useMemo(() => {
    if (!options) {
      // Loading state: render placeholders with stable keys
      return Array.from({ length: PLACEHOLDER_COUNT }, (_, i) => ({
        key: `placeholder-${i}`,
        option: null,
      }));
    }
    // Loaded state: use actual data with stable id-based keys
    return options
      .slice(0, MAX_ITEMS)
      .filter((option): option is NonNullable<typeof option> => option != null)
      .map((option, i) => ({
        key: String(option.id ?? `item-${i}`),
        option,
      }));
  }, [options]);

  return (
    <FlexCol alignItems="stretch">
      {items.map(({ key, option }) => (
        <SweepstakesOptionsContext.Provider value={option} key={key}>
          <SweepstakesListItem />
        </SweepstakesOptionsContext.Provider>
      ))}

      <EntryDialog />
    </FlexCol>
  );
};

export default CurrentSweepstakesListItems;
